module.exports = __webpack_public_path__ + "img/select.866429c7.svg";